"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = __importDefault(require("@graphql-mesh/openapi"));
const BASE_URL = 'https://api.twitter.com/2';
class TwitterHandler extends openapi_1.default {
    constructor({ name, config, cache, pubsub, }) {
        config.source = require.resolve('@graphql-portal/twitter/src/source.json');
        config.baseUrl = BASE_URL;
        config.operationHeaders = config.schemaHeaders = {
            authorization: `Bearer ${config.token}`,
        };
        super({ name, config, cache, pubsub });
    }
}
exports.default = TwitterHandler;
//# sourceMappingURL=handler.js.map